export var SENTRY_RELEASE = "477ea1ec9404ab5d4e9f56c17edfc8104f1bfb64";
